import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/icon-x-default.svg';
import _imports_1 from '@/assets/icon/icon-x-primary.svg';

const _withScopeId = n => (_pushScopeId("data-v-3afb078c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "modal-container"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mask"
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "normal",
  src: _imports_0,
  alt: "x"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hover",
  src: _imports_1,
  alt: "x"
}, null, -1));

const _hoisted_5 = [_hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
    class: _normalizeClass(["modal-box", {
      auto: $props.auto
    }])
  }, [_createElementVNode("div", {
    class: "icon-rounded-wrapper small close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args))
  }, _hoisted_5), _createElementVNode("div", {
    class: _normalizeClass(["content", {
      noPadding: $props.noPadding
    }])
  }, [_renderSlot(_ctx.$slots, "content", {}, undefined, true)], 2)], 2)]);
}